//bundle 39833082167414

// vitality 39749963022454

// multi 39749962072182

// bundle one time 39749964464246

function reChargeProcessCart() {
    function get_cookie(name) {
        return (document.cookie.match("(^|; )" + name + "=([^;]*)") || 0)[2];
    }
    do {
        token = get_cookie("cart");
    } while (token == undefined);
    var myshopify_domain = "{{ shop.permanent_domain }}";
    try {
        var ga_linker = ga.getAll()[0].get("linkerParam");
    } catch (err) {
        var ga_linker = "";
    }

    checkout_url =
        "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" +
        myshopify_domain +
        "&cart_token=" +
        token +
        "&" +
        ga_linker;
    //document.location.href = "https://nutririse.com/cart" || checkout_url;
}

const formData = {
    items: [{ id: "39646218190966", quantity: 1 }],
};

function processAdaptozenSubscription() {
    /*fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
  })
      .then(response => {
          reChargeProcessCart();
      })
      .catch((error) => {
          console.error('Error:', error);
      });*/

    window.location.href =
        "https://nutririse.com/collections/adaptozen/products/adaptozen-bundle";
}

function processWarriorCodeBundleSubscription() {
    /*fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            reChargeProcessCart();
        })
        .catch((error) => {
            console.error('Error:', error);
        });*/

    window.location.href = "https://nutririse.com/products/warrior-code-bundle";
}

const processCustomCart = (variatId) => {
    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: [{ id: variatId, quantity: 1 }] }),
    })
        .then((response) => {
            window.location.href = "https://nutririse.com/cart";
        })
        .catch((error) => {
            console.error("Error:", error);
        });
};

var adaptSubClick = document.getElementById("adaptozen-subscription-button");

if (adaptSubClick) {
    adaptSubClick.addEventListener(
        "click",
        processAdaptozenSubscription,
        false
    );
}

var superfoodGreen = document.getElementById(
    "superfood-greens-custom-buy-button"
);

if (superfoodGreen) {
    superfoodGreen.addEventListener(
        "click",
        () => {
            processCustomCart("39625524117622");
        },
        false
    );
}

var vitamind3k2dropsClick = document.getElementById("drops-custom-buy-button");

if (vitamind3k2dropsClick) {
    vitamind3k2dropsClick.addEventListener(
        "click",
        () => {
            processCustomCart("39625546236022");
        },
        false
    );
}

var adaptozenClick = document.getElementById("adaptozen-custom-buy-button");
if (adaptozenClick) {
    adaptozenClick.addEventListener(
        "click",
        () => {
            processCustomCart("39635449544822");
        },
        false
    );
}

var mensMultiClick = document.getElementById("mens-multi-custom-buy-button");

if (mensMultiClick) {
    mensMultiClick.addEventListener(
        "click",
        () => {
            processCustomCart("39749962072182");
        },
        false
    );
}

var mensVitalityClick = document.getElementById(
    "mens-vitality-custom-buy-button"
);

if (mensVitalityClick) {
    mensVitalityClick.addEventListener(
        "click",
        () => {
            processCustomCart("39749963022454");
        },
        false
    );
}

var warriorCodeBundleClick = document.getElementById(
    "warriorcode-custom-buy-button"
);
if (warriorCodeBundleClick) {
    warriorCodeBundleClick.addEventListener(
        "click",
        () => {
            processCustomCart("39749964464246");
        },
        false
    );
}

var warriorCodeSubscriptionButtonClick = document.getElementById(
    "warriorcode-subscription-button"
);
if (warriorCodeSubscriptionButtonClick) {
    warriorCodeSubscriptionButtonClick.addEventListener(
        "click",
        processWarriorCodeBundleSubscription,
        false
    );
}
